<script>
    import { onMount } from "svelte";

    import { resetGame, switchPage } from "../store";
    import { defeats, victories } from "../texts";

    export let isVictory = false;

    export let score;
    export let maxScore;

    export let promoCode = "muzikanaletu";

    // export let levelBackgroundImage;
    export let levelHeadphonesImage;

    const textStore = isVictory ? victories : defeats;

    function getRandomTexts(store) {
        let min = 0;
        let max = store.length;

        let i = Math.floor(Math.random() * (max - min) + min);
        return store[i];
    }

    let { title, text } = getRandomTexts(textStore);

    onMount(() => {
        dataLayer.push({ event: "game_finish" });
    });
</script>

<style>
    .social-icon {
        margin-left: 0;
        cursor: pointer;
    }

    .custom-white {
        background-color: #f1f1f1;
        color: #1f1f1f;
    }

    @media screen and (max-width: 479px) {
        .social-icon {
            margin-left: 0;
        }
    }
</style>

<div class="wrap">
    <div class="header">
        <a href="https://ichip.ru" target="_blank">
            <img
                src="images/chip-1-2.png"
                loading="lazy"
                alt=""
                class="logo" />
        </a>
        <div class="jbl-logo">
            <div class="bg-white-logo" />
            <a
                href="https://bit.ly/388SagD"
                target="_blank"
                data-gtm="jbl_logo">
                <img
                    src="images/Group-2.png"
                    loading="lazy"
                    alt=""
                    class="logo _2" />
            </a>
        </div>
    </div>
    <div class="section">
        {#if isVictory}
            <img
                src="images/fireworks.png"
                loading="lazy"
                alt=""
                class="fireworks" />
        {/if}
        <div class="hero lose">
            <div class="score-wrap vertical end">
                <h3 class="heading2">Score</h3>
                <h3 class="heading2 score">{score}/{maxScore}</h3>
            </div>
            <h1 class="heading1 margin-bottom centered">{title}</h1>
            <p class="paragraph subheadline centered">{text}</p>
            {#if isVictory}
                <div class="promo">
                    <h3 class="heading2 score">Промокод: {promoCode}</h3>
                </div>
            {/if}
            <div class="lose-image-wrap">
                <img
                    src={levelHeadphonesImage}
                    alt=""
                    loading="lazy"
                    class="tune" />

                <div class="like abs w-embed">
                    <svg
                        width="30"
                        height="30"
                        version="1.1"
                        id="Capa_1"
                        xmlns="http://www.w3.org/2000/svg"
                        xmlns:xlink="http://www.w3.org/1999/xlink"
                        viewBox="0 0 512 512"
                        fill="white">
                        <g>
                            <g>
                                <path
                                    d="M469.51,317c7.14-7.97,11.49-18.49,11.49-30c0-24.81-20.19-45-45-45h-87.34c8.65-26.25,12.34-61.08,12.34-76.01V151
			c0-33.08-26.92-60-60-60h-15c-6.88,0-12.88,4.68-14.55,11.36l-8.17,32.69c-11.45,45.78-47.8,96.29-85.42,105.47
			C171.27,223.84,155,212,136,212H46c-8.28,0-15,6.72-15,15v270c0,8.28,6.72,15,15,15h90c17.89,0,33.37-10.49,40.62-25.65
			l51.54,17.18c16.85,5.62,34.41,8.47,52.18,8.47H406c24.81,0,45-20.19,45-45c0-5.85-1.12-11.45-3.16-16.58
			C466.92,445.21,481,427.72,481,407c0-11.51-4.35-22.03-11.49-30c7.14-7.97,11.49-18.49,11.49-30S476.65,324.97,469.51,317z
			 M151,467c0,8.27-6.73,15-15,15H61V242h75c8.27,0,15,6.73,15,15V467z M406,332h30c8.27,0,15,6.73,15,15c0,8.27-6.73,15-15,15h-30
			c-8.28,0-15,6.72-15,15c0,8.28,6.72,15,15,15h30c8.27,0,15,6.73,15,15c0,8.27-6.73,15-15,15h-30c-8.28,0-15,6.72-15,15
			c0,8.28,6.72,15,15,15c8.27,0,15,6.73,15,15c0,8.27-6.73,15-15,15H280.34c-14.54,0-28.91-2.33-42.7-6.93L181,456.19V270.58
			c23.53-4.47,46.56-19.37,67.35-43.76c20.3-23.82,36.76-55.4,44.03-84.49l5.33-21.33H301c16.54,0,30,13.46,30,30v14.99
			c0,20.14-6.3,58.77-14.36,76.01H286c-8.28,0-15,6.72-15,15c0,8.28,6.72,15,15,15h150c8.27,0,15,6.73,15,15c0,8.27-6.73,15-15,15
			h-30c-8.28,0-15,6.72-15,15C391,325.28,397.72,332,406,332z" />
                            </g>
                        </g>
                        <g>
                            <g>
                                <circle cx="106" cy="437" r="15" />
                            </g>
                        </g>
                        <g>
                            <g>
                                <path
                                    d="M316,0c-8.284,0-15,6.716-15,15v31c0,8.284,6.716,15,15,15s15-6.716,15-15V15C331,6.716,324.284,0,316,0z" />
                            </g>
                        </g>
                        <g>
                            <g>
                                <path
                                    d="M252.36,66.148l-21.213-21.213c-5.857-5.858-15.355-5.858-21.213,0c-5.858,5.858-5.858,15.355,0,21.213l21.213,21.213
			c5.857,5.857,15.356,5.858,21.213,0C258.218,81.503,258.218,72.006,252.36,66.148z" />
                            </g>
                        </g>
                        <g>
                            <g>
                                <path
                                    d="M422.066,44.935c-5.857-5.858-15.355-5.858-21.213,0L379.64,66.147c-5.858,5.858-5.858,15.355,0,21.213
			c5.857,5.858,15.355,5.859,21.213,0.001l21.213-21.213C427.924,60.29,427.924,50.793,422.066,44.935z" />
                            </g>
                        </g>
                        <g />
                        <g />
                        <g />
                        <g />
                        <g />
                        <g />
                        <g />
                        <g />
                        <g />
                        <g />
                        <g />
                        <g />
                        <g />
                        <g />
                        <g />
                    </svg>
                </div>
                <div class="like abs _2 w-embed">
                    <svg
                        width="30"
                        height="30"
                        version="1.1"
                        id="Capa_1"
                        xmlns="http://www.w3.org/2000/svg"
                        xmlns:xlink="http://www.w3.org/1999/xlink"
                        viewBox="0 0 512 512"
                        fill="white">
                        <g>
                            <g>
                                <path
                                    d="M469.51,317c7.14-7.97,11.49-18.49,11.49-30c0-24.81-20.19-45-45-45h-87.34c8.65-26.25,12.34-61.08,12.34-76.01V151
			c0-33.08-26.92-60-60-60h-15c-6.88,0-12.88,4.68-14.55,11.36l-8.17,32.69c-11.45,45.78-47.8,96.29-85.42,105.47
			C171.27,223.84,155,212,136,212H46c-8.28,0-15,6.72-15,15v270c0,8.28,6.72,15,15,15h90c17.89,0,33.37-10.49,40.62-25.65
			l51.54,17.18c16.85,5.62,34.41,8.47,52.18,8.47H406c24.81,0,45-20.19,45-45c0-5.85-1.12-11.45-3.16-16.58
			C466.92,445.21,481,427.72,481,407c0-11.51-4.35-22.03-11.49-30c7.14-7.97,11.49-18.49,11.49-30S476.65,324.97,469.51,317z
			 M151,467c0,8.27-6.73,15-15,15H61V242h75c8.27,0,15,6.73,15,15V467z M406,332h30c8.27,0,15,6.73,15,15c0,8.27-6.73,15-15,15h-30
			c-8.28,0-15,6.72-15,15c0,8.28,6.72,15,15,15h30c8.27,0,15,6.73,15,15c0,8.27-6.73,15-15,15h-30c-8.28,0-15,6.72-15,15
			c0,8.28,6.72,15,15,15c8.27,0,15,6.73,15,15c0,8.27-6.73,15-15,15H280.34c-14.54,0-28.91-2.33-42.7-6.93L181,456.19V270.58
			c23.53-4.47,46.56-19.37,67.35-43.76c20.3-23.82,36.76-55.4,44.03-84.49l5.33-21.33H301c16.54,0,30,13.46,30,30v14.99
			c0,20.14-6.3,58.77-14.36,76.01H286c-8.28,0-15,6.72-15,15c0,8.28,6.72,15,15,15h150c8.27,0,15,6.73,15,15c0,8.27-6.73,15-15,15
			h-30c-8.28,0-15,6.72-15,15C391,325.28,397.72,332,406,332z" />
                            </g>
                        </g>
                        <g>
                            <g>
                                <circle cx="106" cy="437" r="15" />
                            </g>
                        </g>
                        <g>
                            <g>
                                <path
                                    d="M316,0c-8.284,0-15,6.716-15,15v31c0,8.284,6.716,15,15,15s15-6.716,15-15V15C331,6.716,324.284,0,316,0z" />
                            </g>
                        </g>
                        <g>
                            <g>
                                <path
                                    d="M252.36,66.148l-21.213-21.213c-5.857-5.858-15.355-5.858-21.213,0c-5.858,5.858-5.858,15.355,0,21.213l21.213,21.213
			c5.857,5.857,15.356,5.858,21.213,0C258.218,81.503,258.218,72.006,252.36,66.148z" />
                            </g>
                        </g>
                        <g>
                            <g>
                                <path
                                    d="M422.066,44.935c-5.857-5.858-15.355-5.858-21.213,0L379.64,66.147c-5.858,5.858-5.858,15.355,0,21.213
			c5.857,5.858,15.355,5.859,21.213,0.001l21.213-21.213C427.924,60.29,427.924,50.793,422.066,44.935z" />
                            </g>
                        </g>
                        <g />
                        <g />
                        <g />
                        <g />
                        <g />
                        <g />
                        <g />
                        <g />
                        <g />
                        <g />
                        <g />
                        <g />
                        <g />
                        <g />
                        <g />
                    </svg>
                </div>
                <div class="like abs _3 w-embed">
                    <svg
                        width="30"
                        height="30"
                        version="1.1"
                        id="Capa_1"
                        xmlns="http://www.w3.org/2000/svg"
                        xmlns:xlink="http://www.w3.org/1999/xlink"
                        viewBox="0 0 512 512"
                        fill="white">
                        <g>
                            <g>
                                <path
                                    d="M469.51,317c7.14-7.97,11.49-18.49,11.49-30c0-24.81-20.19-45-45-45h-87.34c8.65-26.25,12.34-61.08,12.34-76.01V151
			c0-33.08-26.92-60-60-60h-15c-6.88,0-12.88,4.68-14.55,11.36l-8.17,32.69c-11.45,45.78-47.8,96.29-85.42,105.47
			C171.27,223.84,155,212,136,212H46c-8.28,0-15,6.72-15,15v270c0,8.28,6.72,15,15,15h90c17.89,0,33.37-10.49,40.62-25.65
			l51.54,17.18c16.85,5.62,34.41,8.47,52.18,8.47H406c24.81,0,45-20.19,45-45c0-5.85-1.12-11.45-3.16-16.58
			C466.92,445.21,481,427.72,481,407c0-11.51-4.35-22.03-11.49-30c7.14-7.97,11.49-18.49,11.49-30S476.65,324.97,469.51,317z
			 M151,467c0,8.27-6.73,15-15,15H61V242h75c8.27,0,15,6.73,15,15V467z M406,332h30c8.27,0,15,6.73,15,15c0,8.27-6.73,15-15,15h-30
			c-8.28,0-15,6.72-15,15c0,8.28,6.72,15,15,15h30c8.27,0,15,6.73,15,15c0,8.27-6.73,15-15,15h-30c-8.28,0-15,6.72-15,15
			c0,8.28,6.72,15,15,15c8.27,0,15,6.73,15,15c0,8.27-6.73,15-15,15H280.34c-14.54,0-28.91-2.33-42.7-6.93L181,456.19V270.58
			c23.53-4.47,46.56-19.37,67.35-43.76c20.3-23.82,36.76-55.4,44.03-84.49l5.33-21.33H301c16.54,0,30,13.46,30,30v14.99
			c0,20.14-6.3,58.77-14.36,76.01H286c-8.28,0-15,6.72-15,15c0,8.28,6.72,15,15,15h150c8.27,0,15,6.73,15,15c0,8.27-6.73,15-15,15
			h-30c-8.28,0-15,6.72-15,15C391,325.28,397.72,332,406,332z" />
                            </g>
                        </g>
                        <g>
                            <g>
                                <circle cx="106" cy="437" r="15" />
                            </g>
                        </g>
                        <g>
                            <g>
                                <path
                                    d="M316,0c-8.284,0-15,6.716-15,15v31c0,8.284,6.716,15,15,15s15-6.716,15-15V15C331,6.716,324.284,0,316,0z" />
                            </g>
                        </g>
                        <g>
                            <g>
                                <path
                                    d="M252.36,66.148l-21.213-21.213c-5.857-5.858-15.355-5.858-21.213,0c-5.858,5.858-5.858,15.355,0,21.213l21.213,21.213
			c5.857,5.857,15.356,5.858,21.213,0C258.218,81.503,258.218,72.006,252.36,66.148z" />
                            </g>
                        </g>
                        <g>
                            <g>
                                <path
                                    d="M422.066,44.935c-5.857-5.858-15.355-5.858-21.213,0L379.64,66.147c-5.858,5.858-5.858,15.355,0,21.213
			c5.857,5.858,15.355,5.859,21.213,0.001l21.213-21.213C427.924,60.29,427.924,50.793,422.066,44.935z" />
                            </g>
                        </g>
                        <g />
                        <g />
                        <g />
                        <g />
                        <g />
                        <g />
                        <g />
                        <g />
                        <g />
                        <g />
                        <g />
                        <g />
                        <g />
                        <g />
                        <g />
                    </svg>
                </div>
                <div class="like abs _4 w-embed">
                    <svg
                        width="30"
                        height="30"
                        version="1.1"
                        id="Capa_1"
                        xmlns="http://www.w3.org/2000/svg"
                        xmlns:xlink="http://www.w3.org/1999/xlink"
                        viewBox="0 0 512 512"
                        fill="white">
                        <g>
                            <g>
                                <path
                                    d="M469.51,317c7.14-7.97,11.49-18.49,11.49-30c0-24.81-20.19-45-45-45h-87.34c8.65-26.25,12.34-61.08,12.34-76.01V151
			c0-33.08-26.92-60-60-60h-15c-6.88,0-12.88,4.68-14.55,11.36l-8.17,32.69c-11.45,45.78-47.8,96.29-85.42,105.47
			C171.27,223.84,155,212,136,212H46c-8.28,0-15,6.72-15,15v270c0,8.28,6.72,15,15,15h90c17.89,0,33.37-10.49,40.62-25.65
			l51.54,17.18c16.85,5.62,34.41,8.47,52.18,8.47H406c24.81,0,45-20.19,45-45c0-5.85-1.12-11.45-3.16-16.58
			C466.92,445.21,481,427.72,481,407c0-11.51-4.35-22.03-11.49-30c7.14-7.97,11.49-18.49,11.49-30S476.65,324.97,469.51,317z
			 M151,467c0,8.27-6.73,15-15,15H61V242h75c8.27,0,15,6.73,15,15V467z M406,332h30c8.27,0,15,6.73,15,15c0,8.27-6.73,15-15,15h-30
			c-8.28,0-15,6.72-15,15c0,8.28,6.72,15,15,15h30c8.27,0,15,6.73,15,15c0,8.27-6.73,15-15,15h-30c-8.28,0-15,6.72-15,15
			c0,8.28,6.72,15,15,15c8.27,0,15,6.73,15,15c0,8.27-6.73,15-15,15H280.34c-14.54,0-28.91-2.33-42.7-6.93L181,456.19V270.58
			c23.53-4.47,46.56-19.37,67.35-43.76c20.3-23.82,36.76-55.4,44.03-84.49l5.33-21.33H301c16.54,0,30,13.46,30,30v14.99
			c0,20.14-6.3,58.77-14.36,76.01H286c-8.28,0-15,6.72-15,15c0,8.28,6.72,15,15,15h150c8.27,0,15,6.73,15,15c0,8.27-6.73,15-15,15
			h-30c-8.28,0-15,6.72-15,15C391,325.28,397.72,332,406,332z" />
                            </g>
                        </g>
                        <g>
                            <g>
                                <circle cx="106" cy="437" r="15" />
                            </g>
                        </g>
                        <g>
                            <g>
                                <path
                                    d="M316,0c-8.284,0-15,6.716-15,15v31c0,8.284,6.716,15,15,15s15-6.716,15-15V15C331,6.716,324.284,0,316,0z" />
                            </g>
                        </g>
                        <g>
                            <g>
                                <path
                                    d="M252.36,66.148l-21.213-21.213c-5.857-5.858-15.355-5.858-21.213,0c-5.858,5.858-5.858,15.355,0,21.213l21.213,21.213
			c5.857,5.857,15.356,5.858,21.213,0C258.218,81.503,258.218,72.006,252.36,66.148z" />
                            </g>
                        </g>
                        <g>
                            <g>
                                <path
                                    d="M422.066,44.935c-5.857-5.858-15.355-5.858-21.213,0L379.64,66.147c-5.858,5.858-5.858,15.355,0,21.213
			c5.857,5.858,15.355,5.859,21.213,0.001l21.213-21.213C427.924,60.29,427.924,50.793,422.066,44.935z" />
                            </g>
                        </g>
                        <g />
                        <g />
                        <g />
                        <g />
                        <g />
                        <g />
                        <g />
                        <g />
                        <g />
                        <g />
                        <g />
                        <g />
                        <g />
                        <g />
                        <g />
                    </svg>
                </div>
            </div>

            {#if isVictory}
                <a
                    href="https://bit.ly/2K0zV5a"
                    data-w-id="99ac7538-7bbf-360e-c98c-c864cf7751f3"
                    class="button-hero small w-button"
                    style=""
                    data-gtm="buy_discount">
                    Купить со скидкой
                </a>
            {:else}
                <a
                    href="https://bit.ly/2K0zV5a"
                    data-w-id="99ac7538-7bbf-360e-c98c-c864cf7751f3"
                    class="button-hero small w-button"
                    style=""
                    data-gtm="buy_discount">
                    Перейти в магазин
                </a>
            {/if}
            <div
                data-w-id="99ac7538-7bbf-360e-c98c-c864cf7751f3"
                class="button-hero small w-button custom-white"
                style="margin-top: 0"
                on:click={() => resetGame()}
                data-gtm="try_again">
                Попробовать еще раз
            </div>
            <div class="share-block">
                <h4 class="paragraph subheadline centered">Поделиться</h4>
                <div class="social-wrap">
                    <a
                        href="http://vk.com/share.php?url=https://ichip.ru/jbl-game"
                        data-gtm="social"
                        target="_blank"
                        class="social-icon w-embed">
                        <svg
                            width="28"
                            height="16"
                            viewBox="0 0 28 16"
                            fill="currentColor"
                            xmlns="http://www.w3.org/2000/svg">
                            <path
                                d="M25.7419 15.6643H21.6774C21 15.6643 20.3226 15.4406 19.871 14.8811L17.5 12.5315C17.0484 12.0839 16.4839 12.0839 16.0323 12.5315C15.8065 12.7552 15.6935 12.979 15.6935 13.2028V14.2098C15.6935 14.993 15.0161 15.5524 14.3387 15.5524H10.7258C8.12903 15.5524 3.95161 9.84615 0.903226 4.92308C0.33871 4.02797 0 2.90909 0 1.79021V1.45455C0 0.671329 0.677419 0 1.46774 0H5.08065C5.30645 0 5.53226 0.111888 5.53226 0.335664C6.32258 1.9021 8.58065 6.04196 9.37097 6.93706C9.59677 7.16084 9.82258 7.27273 9.93548 7.27273C10.0484 7.27273 10.0484 7.27273 10.1613 7.16084V2.7972C10.1613 2.23776 9.93548 1.67832 9.48387 1.23077L9.14516 1.00699C8.91936 0.783217 8.91936 0.447552 9.14516 0.223776C9.25807 0.111888 9.48387 0 9.59677 0H14.5645C15.2419 0 15.8065 0.559441 15.8065 1.23077V6.93706C16.1452 7.04895 16.7097 7.27273 17.1613 6.82517C17.6129 6.37762 18.8548 4.02797 20.2097 0.895105C20.3226 0.335664 20.8871 0 21.5645 0H25.5161C26.4194 0 27.0968 0.671329 27.0968 1.56643C27.0968 2.46154 26.7581 3.35664 26.1936 4.02797L22.5806 8.5035V9.17482L26.6452 13.2028C27.4355 13.2028 28 13.7622 28 14.5455C28 15.3287 27.4355 15.8881 26.6452 15.8881C26.3065 16 25.9677 15.8881 25.7419 15.6643ZM16.8226 11.1888C17.3871 11.1888 17.9516 11.4126 18.4032 11.8601L20.7742 14.2098C21 14.4336 21.4516 14.6573 21.7903 14.6573H25.8548C25.9677 14.6573 26.0806 14.6573 26.0806 14.5455C26.0806 14.4336 26.0806 14.3217 26.0806 14.3217L21.7903 10.0699C21.5645 9.84615 21.4516 9.62238 21.4516 9.51049V8.39161C21.4516 8.27972 21.4516 8.16783 21.5645 8.05594L25.2903 3.35664C25.7419 2.90909 25.9677 2.23776 25.9677 1.56643C25.9677 1.34266 25.7419 1.11888 25.5161 1.11888H21.5645C21.4516 1.11888 21.2258 1.23077 21.2258 1.34266C20.2097 3.8042 18.7419 6.93706 17.9516 7.72028C16.9355 8.61539 15.5806 8.16783 15.0161 7.72028C14.7903 7.60839 14.6774 7.4965 14.6774 7.27273V1.23077C14.6774 1.11888 14.6774 1.11888 14.5645 1.11888H10.8387C11.1774 1.67832 11.2903 2.23776 11.2903 2.7972V7.27273C11.2903 7.38462 11.2903 7.4965 11.1774 7.60839C11.1774 7.72028 10.7258 8.27972 10.0484 8.27972C9.59677 8.39161 9.14516 8.16783 8.58064 7.72028C7.67742 6.71329 5.41935 2.34965 4.74194 1.11888H1.46774C1.24194 1.11888 1.12903 1.23077 1.12903 1.45455V1.79021C1.12903 2.68531 1.35484 3.69231 1.91935 4.47552C5.75806 10.6294 9.14516 14.5455 10.7258 14.5455H14.4516C14.5645 14.5455 14.6774 14.4336 14.6774 14.3217V13.3147C14.6774 12.1958 15.6935 11.1888 16.8226 11.1888Z" />
                        </svg>
                    </a>

                    <a
                        href="https://t.me/share/url?url=https%3A%2F%2Fichip.ru%2Fjbl-game&text=%D0%97%D0%B0%D0%BB%D0%B8%D0%BF%D0%B0%D1%82%D0%B5%D0%BB%D1%8C%D0%BD%D0%B0%D1%8F%20%D0%B8%D0%B3%D1%80%D0%B0%20%D0%BE%D1%82%20ICHIP%20%D0%B8%20JBL.%20%D0%9F%D1%80%D0%BE%D1%85%D0%BE%D0%B4%D0%B8%20%D0%BC%D1%83%D0%B7%D1%8B%D0%BA%D0%B0%D0%BB%D1%8C%D0%BD%D1%8B%D0%B5%20%D1%83%D1%80%D0%BE%D0%B2%D0%BD%D0%B8%3A%20%D0%BB%D0%BE%D0%B2%D0%B8%20%D0%BA%D0%B0%D1%87%D0%B5%D1%81%D1%82%D0%B2%D0%B5%D0%BD%D0%BD%D1%8B%D0%B5%20%D0%BD%D0%BE%D1%82%D1%8B%20%D0%BD%D0%B0%20%D0%BB%D0%B5%D1%82%D1%83%20%D0%B8%20%D0%B7%D0%B0%D0%B1%D0%B8%D1%80%D0%B0%D0%B9%20%D1%81%D0%BA%D0%B8%D0%B4%D0%BE%D1%87%D0%BD%D1%8B%D0%B9%20%D0%BF%D1%80%D0%BE%D0%BC%D0%BE%D0%BA%D0%BE%D0%B4%20%D0%BD%D0%B0%20%D0%BD%D0%BE%D0%B2%D1%8B%D0%B5%20%D0%BD%D0%B0%D1%83%D1%88%D0%BD%D0%B8%D0%BA%D0%B8%20JBL%20TUNE%20225TWS"
                        data-gtm="social"
                        target="_blank"
                        class="social-icon w-embed">
                        <svg
                            width="23"
                            height="24"
                            viewBox="0 0 23 24"
                            fill="currentColor"
                            xmlns="http://www.w3.org/2000/svg">
                            <path
                                d="M0.397687 11.5956L6.02215 14.8863C6.23969 15.0123 6.49652 15.0033 6.70448 14.8604L11.7108 11.4438L8.68056 14.596C8.52627 14.7569 8.4381 14.9864 8.4381 15.2283V22.9064C8.4381 23.7164 9.31881 24.0573 9.73185 23.4138L12.1631 19.6191L18.1757 23.6388C18.5974 23.9234 19.1379 23.6376 19.2356 23.0718L22.9856 1.13427C23.0977 0.475015 22.539 -0.0627345 22.0196 0.182516L0.457104 10.0544C-0.12173 10.3199 -0.159105 11.2705 0.397687 11.5956ZM21.3181 2.31552L18.0224 21.5946L12.3251 17.7854C12.0146 17.5773 11.615 17.6695 11.3946 18.0115L9.8756 20.3819V15.6074L18.0703 7.08439C18.7191 6.41052 17.9735 5.21239 17.2327 5.72314L6.31731 13.1729L2.49165 10.9353L21.3181 2.31552Z" />
                        </svg>
                    </a>

                    <a
                        href="https://twitter.com/intent/tweet?url=https://ichip.ru/jbl-game&text=Залипательная игра от ICHIP и JBL. Проходи музыкальные уровни: лови качественные ноты на лету и забирай скидочный промокод на новые наушники JBL TUNE 225TWS"
                        data-gtm="social"
                        target="_blank"
                        class="social-icon w-embed">
                        <svg
                            width="24"
                            height="19"
                            viewBox="0 0 24 19"
                            fill="currentColor"
                            xmlns="http://www.w3.org/2000/svg">
                            <path
                                d="M0.472992 16.7785C2.69499 18.1298 5.28099 18.8437 7.95099 18.8437C11.861 18.8437 15.444 17.4043 18.041 14.7909C20.526 12.2897 21.893 8.92879 21.825 5.51808C22.767 4.74567 23.875 3.27079 23.875 1.83329C23.875 1.28225 23.251 0.932457 22.745 1.21325C21.86 1.71158 21.053 1.84192 20.223 1.61862C18.528 0.0354574 16.005 -0.298043 13.879 0.800207C12.021 1.75854 10.988 3.51229 11.081 5.42896C7.94199 5.06192 5.04199 3.5535 3.01999 1.20942C2.68799 0.827041 2.05799 0.872082 1.79399 1.30525C0.819992 2.90375 0.829992 4.75621 1.67699 6.25217C1.27399 6.32021 1.02499 6.64508 1.02499 6.99679C1.02499 8.50042 1.73099 9.88233 2.86799 10.8253C2.65599 11.0208 2.58599 11.3112 2.67599 11.57C3.17599 13.0094 4.30799 14.1345 5.72299 14.698C4.18399 15.4023 2.48199 15.6371 0.966992 15.4589C0.182992 15.3573 -0.204008 16.3674 0.472992 16.7785ZM8.15599 14.9443C8.71699 14.5312 8.41899 13.6706 7.71499 13.6563C6.47499 13.6313 5.34599 13.0458 4.64299 12.1248C4.98199 12.1038 5.33299 12.0539 5.66699 11.9677C6.42799 11.7703 6.39199 10.718 5.61899 10.5695C4.21599 10.2992 3.11499 9.31979 2.70199 8.05863C3.07899 8.14775 3.46299 8.19758 3.84599 8.20429C4.60499 8.20813 4.89199 7.27567 4.27299 6.88563C2.87799 6.00492 2.28299 4.44954 2.67699 2.98712C5.11299 5.35229 8.41799 6.77733 11.914 6.93833C12.415 6.96804 12.791 6.51667 12.681 6.05954C12.206 4.08633 13.356 2.70346 14.591 2.06617C15.813 1.43367 17.775 1.23625 19.279 2.7485C19.726 3.19987 21.234 3.21712 22.001 3.04558C21.657 3.66658 21.128 4.25596 20.633 4.58754C20.422 4.72937 20.301 4.96513 20.314 5.21142C20.475 8.35954 19.251 11.4895 16.956 13.7981C14.644 16.124 11.447 17.4053 7.95199 17.4053C6.56199 17.4053 5.19899 17.1887 3.91099 16.7708C5.45099 16.4853 6.91399 15.8604 8.15599 14.9443Z" />
                        </svg>
                    </a>
                    <a
                        href="https://www.facebook.com/sharer/sharer.php?u=https://ichip.ru/jbl-game"
                        data-gtm="social"
                        target="_blank"
                        class="social-icon w-embed">
                        <svg
                            width="14"
                            height="23"
                            viewBox="0 0 14 23"
                            fill="currentColor"
                            xmlns="http://www.w3.org/2000/svg">
                            <path
                                d="M8.62036 22.9551H4.76946C4.12623 22.9551 3.603 22.4546 3.603 21.8394V13.5317H1.3563C0.713073 13.5317 0.189835 13.031 0.189835 12.416V8.8561C0.189835 8.24088 0.713073 7.74043 1.3563 7.74043H3.603V5.95776C3.603 4.19019 4.18329 2.68636 5.28095 1.60912C6.38357 0.526955 7.92448 -0.0449219 9.73711 -0.0449219L12.674 -0.0403595C13.3161 -0.0393066 13.8384 0.461151 13.8384 1.07532V4.38059C13.8384 4.9958 13.3154 5.49626 12.6723 5.49626L10.695 5.49696C10.0919 5.49696 9.93837 5.6126 9.90553 5.64805C9.85141 5.70683 9.78701 5.87301 9.78701 6.33188V7.74025H12.5237C12.7298 7.74025 12.9294 7.78886 13.1009 7.88046C13.471 8.07822 13.701 8.45216 13.701 8.85628L13.6996 12.4162C13.6996 13.031 13.1763 13.5315 12.5331 13.5315H9.78701V21.8394C9.78701 22.4546 9.26359 22.9551 8.62036 22.9551ZM5.01273 21.6067H8.37709V12.928C8.37709 12.5172 8.72659 12.1831 9.15589 12.1831H12.2898L12.2911 9.08878H9.15571C8.72641 9.08878 8.37709 8.75468 8.37709 8.34389V6.33188C8.37709 5.8051 8.43305 5.20602 8.84877 4.75575C9.3511 4.21143 10.1427 4.14861 10.6946 4.14861L12.4287 4.1479V1.30765L9.73601 1.30344C6.82297 1.30344 5.01273 3.08698 5.01273 5.95776V8.34389C5.01273 8.7545 4.66342 9.08878 4.23411 9.08878H1.59957V12.1831H4.23411C4.66342 12.1831 5.01273 12.5172 5.01273 12.928V21.6067ZM12.6712 1.308H12.6714H12.6712Z" />
                        </svg>
                    </a>
                </div>
            </div>
        </div>
    </div>
</div>
